package com.iregained.eventapp.components.sections.footer.sections

import androidx.compose.runtime.Composable
import com.iregained.eventapp.components.sections.footer.styles.SocialIconStyle
import com.iregained.eventapp.theme.toSitePalette
import com.iregained.eventapp.utils.LocalBreakpoint
import com.iregained.eventapp.utils.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.A

private data class SocialLink(val url: String, val iconPath: String, val altText: String)

private val staticSocialLinks = listOf(
    SocialLink("https://www.linkedin.com/company/iregained-inc/", Res.Images.Icons.LINKEDIN, "LinkedIn"),
    SocialLink("https://www.facebook.com/Iregainedinc/", Res.Images.Icons.FACEBOOK, "X (Twitter)"),
    SocialLink("https://www.instagram.com/iregained_inc/", Res.Images.Icons.INSTAGRAM, "Facebook")
)

@Composable
fun MainFooter() {
    val breakpoint = LocalBreakpoint.current
    val isDesktop = breakpoint >= Res.Breakpoints.LG

    Column(
        modifier = Modifier.fillMaxWidth().backgroundColor(Colors.White)
            .borderTop(1.px, LineStyle.Solid, ColorMode.current.toSitePalette().custom.divider)
            .padding(topBottom = 24.px, leftRight = 5.percent), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (isDesktop) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                CopyrightText()
                SocialIcons()
            }
        } else {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                SocialIcons()
                CopyrightText()
            }
        }
    }
}

@Composable
private fun CopyrightText() {
    SpanText(
        text = "© 2026 IRegained Inc. Secure Booking System.",
        modifier = Modifier.fontSize(14.px).color(ColorMode.current.toSitePalette().custom.darkText)
    )
}

@Composable
private fun SocialIcons() {
    Row(
        modifier = Modifier.gap(15.px), verticalAlignment = Alignment.CenterVertically
    ) {
        staticSocialLinks.forEach { social ->
            A(
                href = social.url, attrs = Modifier.toAttrs { attr("target", "_blank") }) {
                Image(
                    src = social.iconPath,
                    alt = social.altText,
                    modifier = SocialIconStyle.toModifier() // Apply the interactive style here!
                        .userSelect(UserSelect.None)
                        .size(26.px)
                        .borderRadius(5.px)
                        .overflow(Overflow.Hidden)
                        .cursor(Cursor.Pointer)
                )
            }
        }
    }
}